import type {
  LookupOption,
  WarehouseApiResponse,
  WarehouseCountMetric,
  WarehouseCountSummary,
  WarehouseListResponse,
  WarehouseResource,
} from "src/services/warehouseService";

export const isResourceActive = (resource: WarehouseResource) =>
  typeof resource.active === "object"
    ? Boolean(resource.active?.id)
    : Boolean(resource.active);

export const normalizeWarehouseResponse = (
  response: WarehouseListResponse | WarehouseResource[] | undefined,
) => {
  if (Array.isArray(response)) {
    return {
      resources: response,
      total: response.length,
    };
  }

  const resources =
    response?.warehouses ??
    response?.content ??
    response?.items ??
    response?.data ??
    [];

  return {
    resources,
    total:
      response?.totalElements ??
      response?.totalItems ??
      response?.total ??
      resources.length,
  };
};

export const getResourcesFromApi = (data?: WarehouseApiResponse) => {
  const response = data?.response;

  if (Array.isArray(response)) {
    return response;
  }

  return normalizeWarehouseResponse(response).resources;
};

export const getLookupOptions = (
  data: { response?: LookupOption[] } | LookupOption[] | undefined,
) => (Array.isArray(data) ? data : (data?.response ?? []));

export const createWarehouseCountMetrics = (
  counts?: WarehouseCountSummary,
): WarehouseCountMetric[] => [
  {
    key: "warehouses",
    labelKey: "warehouses",
    value: counts?.warehouses,
  },
  {
    key: "areas",
    labelKey: "areas",
    value: counts?.areas,
  },
  {
    key: "lanes",
    labelKey: "lanes",
    value: counts?.lanes,
  },
  {
    key: "shelves",
    labelKey: "shelves",
    value: counts?.shelves,
  },
  {
    key: "positions",
    labelKey: "positions",
    value: counts?.positions,
  },
];
